module.exports = __webpack_public_path__ + "static/media/icomoon.82c3591c.eot";